export default __webpack_public_path__ + "static/office-3d130da0b91d9d2459a161d071210ac1.jpg";